<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="linespace" id="disclaimer"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="pg_7"><strong><span class="smallcaps">SPECIAL THANKS TO</span> :</strong></a></p><a id="pg_7">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para">Marlene Stringer and Barbara Bova<br/>Tom Doherty and Paul Stevens<br/>Jason and Jeremy<br/>Grace West<br/>and Valette, Jake and Charlie</p>
</a></section><a id="pg_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// disclaimer.vue?09c19e3c